module.exports = __webpack_public_path__ + "Neeko.91d182fd.atlas";